export const MINIMUM_MESSAGES_FOR_POPUP = 4;
export const PRIVACY_POLICY = "https://unibuddy.com/privacy-policy/";
export const TERMS_AND_CONDITIONS = "https://unibuddy.com/terms-of-use/";
